<template>
  <label>
    <select
      v-model="selectedOption"
      :aria-label="'filter dropdown for ' + name"
    >
      <option disabled="disabled" :value="null" default>{{ name }}</option>
      <option v-for="option in options" :value="option" :key="option.id">
        {{ option.title }}
      </option>
    </select>
  </label>
</template>

<script lang="ts">
import Vue from "vue";
import { TaxonomyTag } from "../client/src/models/index";

export default Vue.extend({
  name: "FilterDropDown",
  props: {
    name: {
      type: String,
      required: true,
      default: ""
    },
    open: {
      type: Boolean
    },
    options: {
      type: Array as () => TaxonomyTag[],
      required: true,
      default: () => []
    },
    active: {
      type: Array as () => TaxonomyTag[],
      required: true,
      default: () => []
    }
  },
  data() {
    return {
      selectedOption: null as TaxonomyTag
    };
  },
  computed: {
    tabIndex() {
      return this.active ? 0 : -1;
    }
  },
  watch: {
    selectedOption: function() {
      if (this.$data.selectedOption !== null) {
        const emitObject = {
          title: this.$data.selectedOption.title,
          id: this.$data.selectedOption.id,
          categoryId: this.$data.selectedOption.categoryId,
          count: this.$data.selectedOption.count
        } as TaxonomyTag;
        this.$emit("inputChange", emitObject);
        this.$data.selectedOption = null;
      }
    }
  },
  methods: {
    isChecked(id: string): boolean {
      return (
        this.$props.active
          .map(function(e: TaxonomyTag) {
            return e.id;
          })
          .indexOf(id) > -1
      );
    },
    showCheckboxes() {
      this.$emit("toggleFilters");
    }
  }
});
</script>
